import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row
} from "reactstrap";
import styles from './styles.module.scss';
import Link from "next/link"

export const BlogDetail = ({
    content,
    image,
    textbox,
    contentBelowTextbox,
    className = "",
}) => {

    return (
        <section className={`${styles.root} ${className}`}>
            <Container>
                <Row>
                    {image &&
                        <Col md={5} className="pe-md-5 mb-5 mb-md-0">
                            <div className="pe-md-5">
                                <div className="img-wrapper rounded-3 overflow-hidden shadow">
                                    <SourceFlowImage
                                        src={image || image?.url || "/site-assets/images/image-placeholder.webp"}
                                        size="1000x1000"
                                        alt={image?.alt || "Blog Image"}
                                        className="card-img"
                                        width="100%"
                                        height="100%"
                                />
                            </div>
                        </div>
                    </Col>
                    }
                    <Col md={image ? 7 : 12}>
                        {content ?
                            <div className="description" dangerouslySetInnerHTML={{ __html: content }} />
                            : ""}
                        {textbox &&
                            <div className={styles.textbox}>
                                <div dangerouslySetInnerHTML={{ __html: textbox }} />
                            </div>
                        }
                        {contentBelowTextbox ?
                            <div className="description" dangerouslySetInnerHTML={{ __html: contentBelowTextbox }} />
                            : ""}
                    </Col>
                </Row>
            </Container>
        </section >
    )
}

export default BlogDetail;